import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { AdminPage } from "./pages/AdminPage.js";
import { InvalidPage } from "./pages/InvalidPage.js";
import { InvitePage } from "./pages/InvitePage.js";
import { PreviewPage } from "./pages/PreviewPage.js";
import { SeatsPage } from "./pages/SeatsPage.js";
import "./styles.css";

const router = createBrowserRouter([
  { path: "/i/:token", element: <InvitePage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/seats/:eventId", element: <SeatsPage /> },
  // Dev-only device preview harness; not registered in production builds.
  ...(import.meta.env.DEV ? [{ path: "/preview", element: <PreviewPage /> }] : []),
  // Root and anything unmatched fall through to the generic invalid page,
  // which leaks nothing about why an invite failed.
  { path: "/", element: <Navigate to="/invalid" replace /> },
  { path: "/invalid", element: <InvalidPage /> },
  { path: "*", element: <InvalidPage /> },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
